//#region src/customer_auth_provider.ts
var CustomerAuthProvider = /* @__PURE__ */ function(CustomerAuthProvider) {
	CustomerAuthProvider["Bite"] = "bite";
	CustomerAuthProvider["Paytronix"] = "paytronix";
	return CustomerAuthProvider;
}(CustomerAuthProvider || {});
//#endregion
export { CustomerAuthProvider };

//# sourceMappingURL=customer_auth_provider.js.map